import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(liter, total, bonus, percentage) {
  return { liter, total, bonus, percentage };
}

export default function BasicTable({ list }) {
  console.log(list);
  const rows = [];

  list.map(({ liter, total, bonus, percentage }) => {
    return rows.push(createData(liter, total, bonus, percentage));
  });

  const sortRows = rows.sort((a, b) => {
    return b.percentage - a.percentage;
  });

  return (
    <TableContainer component={Paper} sx={{ my: 2 }}>
      <Table size="small" aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">리터</TableCell>
            <TableCell align="center">총금액</TableCell>
            <TableCell align="center">적립액</TableCell>
            <TableCell align="center">적립률</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortRows.map((row) => (
            <TableRow
              key={row.liter}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell align="center" component="th" scope="row">
                {row.liter}
              </TableCell>
              <TableCell align="center">
                {row.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              </TableCell>
              <TableCell align="center">{row.bonus}</TableCell>
              <TableCell align="center">{row.percentage}%</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
